import { QueryClient } from '@tanstack/react-query';

/** Shared QueryClient — default stale window suits list/static schedule data. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

/** Unwrap additive list envelopes (`{ items }`) or legacy arrays. */
export function unwrapListResponse(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.items)) return data.items;
  return [];
}
